import { render, staticRenderFns } from "./cadlancamentospdvs.vue?vue&type=template&id=354af155&"
import script from "./cadlancamentospdvs.vue?vue&type=script&lang=js&"
export * from "./cadlancamentospdvs.vue?vue&type=script&lang=js&"
import style0 from "./cadlancamentospdvs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports